import { Token } from "@/lib/classes/BaseNetwork";
import { cryptocurrencies, NetworkKey } from "@/lib/constants/cryptos";

export const getTokenBalances = async (
  baseUrl: string,
  network: NetworkKey,
): Promise<Token[]> => {
  try {
    const res = await fetch(`${baseUrl}/api/balances?network=${network}`, {
      credentials: "include",
    });

    const data = (await res.json()) as Token[];
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getTokens = async (
  baseUrl: string,
  cryptoKeys?: NetworkKey[],
): Promise<Record<NetworkKey, Token[] | null>> => {
  try {
    const filteredCryptos = Object.entries(cryptocurrencies)
      .filter(([key]) => (cryptoKeys ? cryptoKeys.includes(key) : true))
      .reduce(
        (p, [key, value]) => ({ ...p, [key]: value }),
        {} as typeof cryptocurrencies,
      );

    const res = await Promise.allSettled(
      Object.keys(filteredCryptos).map(async network => {
        return getTokenBalances(baseUrl, network);
      }),
    );

    const tokens = res.reduce(
      (p, c, i) => {
        if (c.status !== "fulfilled") {
          return { ...p, [Object.keys(filteredCryptos)[i]]: null };
        }

        return { ...p, [Object.keys(filteredCryptos)[i]]: c.value };
      },
      {} as Record<NetworkKey, Token[] | null>,
    );

    return tokens;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
